var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn screening personPage withTabs" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "9" } },
            [
              _c(
                "b-tabs",
                {
                  staticClass: "screening__tabs",
                  model: {
                    value: _vm.tabIndex,
                    callback: function($$v) {
                      _vm.tabIndex = $$v
                    },
                    expression: "tabIndex"
                  }
                },
                [
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Introduction",
                        disabled: _vm.disabledIntroTab
                      }
                    },
                    [
                      _c("b-card", [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "screening__header screening__header--center"
                          },
                          [
                            _vm._v(
                              "\n                            Louisiana Child and Youth Sex Trafficking Identification Tool\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "screening__description" }, [
                          _vm._v(
                            "\n                            The purpose of this tool is to support the identification of children and youth (under 21 years old) who may be victims of sex trafficking.\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "screening__description" }, [
                          _c("b", [
                            _vm._v(
                              "\n                                Instructions:\n                            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                                This tool is to be used as a narrative assessment. "
                            ),
                            _c("b", [
                              _vm._v(
                                "The indicators outlined in the tool should not be asked directly to the child/youth"
                              )
                            ]),
                            _vm._v(
                              ". To determine if a child or youth may be a victim of sex trafficking, "
                            ),
                            _c("b", [
                              _vm._v("please complete the tool in its entirety")
                            ]),
                            _vm._v(
                              ". Regardless of the tool's findings, if you have any suspicion or concern of sex trafficking involving a child, please make a report to the "
                            ),
                            _c(
                              "a",
                              { attrs: { target: "_blank", href: "#" } },
                              [_vm._v("DCFS")]
                            ),
                            _vm._v(
                              " Child Abuse/Neglect Hotline at 855-452-5437. "
                            ),
                            _c("i", [
                              _vm._v(
                                "For the complete instructions, please refer to the "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href:
                                      "https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/Supplementary.User.Guide_LSTTpdf.1.pdf"
                                  }
                                },
                                [_vm._v("Supplementary User Guide")]
                              )
                            ]),
                            _vm._v(".\n                            ")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "screening__description" }, [
                          _vm._v(
                            "For questions regarding this tool, please contact the Governor's Office of Human Trafficking Prevention at "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "mailto:humantrafficking@la.gov" }
                            },
                            [_vm._v("humantrafficking@la.gov")]
                          ),
                          _vm._v(".")
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("h4", { staticClass: "screening__description" }, [
                          _vm._v("Pre-Screening Criteria")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "screening__description" }, [
                          _vm._v(
                            "To ensure that the the Louisiana Child and Youth Sex Trafficking Identification Tool is implemented consistently, select the screening criteria that applies to the child/youth."
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "prelimDiv",
                            staticStyle: { paddingLeft: "1.45em" }
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  disabled: _vm.isTraffickingScreeningCreated,
                                  "label-size": "lg",
                                  "label-class": "bold",
                                  label: ""
                                }
                              },
                              _vm._l(
                                Object.entries(_vm.prelimFields["Main"]),
                                function(ref) {
                                  var key = ref[0]
                                  var value = ref[1]
                                  return _c(
                                    "div",
                                    { key: key },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          staticClass: "radioCheckbox",
                                          attrs: {
                                            value: key,
                                            name: "prelimMainSelection"
                                          },
                                          model: {
                                            value:
                                              _vm.prelimRadioConditionalModel,
                                            callback: function($$v) {
                                              _vm.prelimRadioConditionalModel = $$v
                                            },
                                            expression:
                                              "prelimRadioConditionalModel"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(value.desc) +
                                              "\n                                        "
                                          ),
                                          key === "prelim_selective" &&
                                          _vm.traffickingScreening[
                                            "prelim_selective"
                                          ] === true
                                            ? _c(
                                                "div",
                                                [
                                                  _vm._l(
                                                    Object.entries(
                                                      _vm.prelimFields[
                                                        "Selective"
                                                      ]
                                                    ),
                                                    function(ref) {
                                                      var sKey = ref[0]
                                                      var sValue = ref[1]
                                                      return _c(
                                                        "b-form-checkbox",
                                                        {
                                                          key: sKey,
                                                          class: {
                                                            bold:
                                                              sValue.boldDesc
                                                          },
                                                          attrs: { size: "lg" },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .traffickingScreening[
                                                                sKey
                                                              ],
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.traffickingScreening,
                                                                sKey,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "traffickingScreening[sKey]"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                " +
                                                              _vm._s(
                                                                sValue.desc
                                                              ) +
                                                              "\n                                            "
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.prelimSelectiveOptionsError &&
                                                            _vm
                                                              .traffickingScreening[
                                                              key
                                                            ],
                                                          expression:
                                                            "prelimSelectiveOptionsError && traffickingScreening[key]"
                                                        }
                                                      ],
                                                      staticClass: "text-info"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                Selecting a selective screening criteria is required.\n                                            "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          value.type === "other"
                                            ? _c(
                                                "div",
                                                [
                                                  _vm.traffickingScreening[key]
                                                    ? _c("b-form-textarea", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: "required",
                                                            expression:
                                                              "'required'"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "screening__form-input",
                                                        attrs: {
                                                          "data-vv-name":
                                                            value.textVar,
                                                          "data-vv-as": "Other",
                                                          id: value.textVar,
                                                          name: value.textVar,
                                                          maxlength: 255
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .traffickingScreening[
                                                              value.textVar
                                                            ],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.traffickingScreening,
                                                              value.textVar,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "traffickingScreening[value.textVar]"
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.inputValidationErrors.has(
                                                              value.textVar
                                                            ) &&
                                                            _vm
                                                              .traffickingScreening[
                                                              key
                                                            ],
                                                          expression:
                                                            "inputValidationErrors.has(value.textVar) && traffickingScreening[key]"
                                                        }
                                                      ],
                                                      staticClass: "text-info"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm.inputValidationErrors.first(
                                                              value.textVar
                                                            )
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isExisting
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "screening__button-wrapper button-container"
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "secondary" },
                                    on: { click: _vm.cancelModal }
                                  },
                                  [_vm._v("Cancel")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary" },
                                    on: { click: _vm.completePrelim }
                                  },
                                  [_vm._v("Next")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Screening",
                        disabled: _vm.disabledScreeningTab
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-tabs",
                                {
                                  class: {
                                    screening__tabs: true,
                                    nestedTabs: true,
                                    "fontSize-xs":
                                      _vm.isTraffickingScreeningCreated,
                                    "fontSize-m": !_vm.isTraffickingScreeningCreated
                                  },
                                  model: {
                                    value: _vm.screeningTabIndex,
                                    callback: function($$v) {
                                      _vm.screeningTabIndex = $$v
                                    },
                                    expression: "screeningTabIndex"
                                  }
                                },
                                [
                                  _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title:
                                          "Section 1: Commercial Sexual Activity"
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "screening__header screening__header--italic"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        Has the child/youth ever engaged in sex or sex acts for anything of value?\n                                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c("i", [
                                          _vm._v(
                                            "Items of value may include money, food, a place to stay, drugs, gifts, transportation, or something else. Select all that apply."
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "screening__form" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.isTraffickingScreeningCreated ||
                                                  _vm.s1Disabled,
                                                "label-size": "lg",
                                                "label-class": "bold",
                                                label: "Exploitation Indicators"
                                              }
                                            },
                                            [
                                              _c("p", [
                                                _vm._v("The child/youth has:")
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(
                                                Object.entries(
                                                  _vm.section1Fields[
                                                    "Exploitation"
                                                  ]
                                                ),
                                                function(ref) {
                                                  var key = ref[0]
                                                  var value = ref[1]
                                                  return _c(
                                                    "b-form-checkbox",
                                                    {
                                                      key: key,
                                                      class: {
                                                        bold: value.boldDesc
                                                      },
                                                      attrs: { size: "lg" },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .traffickingScreening[
                                                            key
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.traffickingScreening,
                                                            key,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "traffickingScreening[key]"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(value.desc) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.isTraffickingScreeningCreated,
                                                "label-size": "lg",
                                                "label-class": "bold",
                                                label:
                                                  "Vulnerability Indicators"
                                              }
                                            },
                                            [
                                              _c("p", [
                                                _vm._v("The child/youth has:")
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(
                                                Object.entries(
                                                  _vm.section1Fields[
                                                    "Vulnerability"
                                                  ]["0"]
                                                ),
                                                function(ref) {
                                                  var key = ref[0]
                                                  var value = ref[1]
                                                  return _c(
                                                    "b-form-checkbox",
                                                    {
                                                      key: key,
                                                      class: {
                                                        bold: value.boldDesc
                                                      },
                                                      attrs: {
                                                        disabled:
                                                          _vm.s1Disabled,
                                                        size: "lg"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .traffickingScreening[
                                                            key
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.traffickingScreening,
                                                            key,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "traffickingScreening[key]"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(value.desc) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v("The child/youth is:")
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(
                                                Object.entries(
                                                  _vm.section1Fields[
                                                    "Vulnerability"
                                                  ]["1"]
                                                ),
                                                function(ref) {
                                                  var key = ref[0]
                                                  var value = ref[1]
                                                  return _c(
                                                    "div",
                                                    { key: key },
                                                    [
                                                      !value.type
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  class: {
                                                                    bold:
                                                                      value.boldDesc,
                                                                    marginTop32: key.includes(
                                                                      "no_circumstances"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    disabled:
                                                                      !key.includes(
                                                                        "no_circumstances"
                                                                      ) &&
                                                                      _vm.s1Disabled,
                                                                    size: "lg"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .traffickingScreening[
                                                                        key
                                                                      ],
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.traffickingScreening,
                                                                        key,
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "traffickingScreening[key]"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        value.desc
                                                                      ) +
                                                                      "\n                                                "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      value.type === "other"
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.s1Disabled,
                                                                    size: "lg"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .traffickingScreening[
                                                                        key
                                                                      ],
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.traffickingScreening,
                                                                        key,
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "traffickingScreening[key]"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        value.desc
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm
                                                                    .traffickingScreening[
                                                                    key
                                                                  ]
                                                                    ? _c(
                                                                        "b-form-textarea",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                "required",
                                                                              expression:
                                                                                "'required'"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "screening__form-input",
                                                                          attrs: {
                                                                            "data-vv-name":
                                                                              value.textVar,
                                                                            "data-vv-as":
                                                                              "Other",
                                                                            id:
                                                                              value.textVar,
                                                                            name:
                                                                              value.textVar,
                                                                            maxlength: 255
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .traffickingScreening[
                                                                                value
                                                                                  .textVar
                                                                              ],
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.traffickingScreening,
                                                                                value.textVar,
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "traffickingScreening[value.textVar]"
                                                                          }
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm.inputValidationErrors.has(
                                                                              value.textVar
                                                                            ) &&
                                                                            _vm
                                                                              .traffickingScreening[
                                                                              key
                                                                            ],
                                                                          expression:
                                                                            "inputValidationErrors.has(value.textVar) && traffickingScreening[key]"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "text-info"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            _vm.inputValidationErrors.first(
                                                                              value.textVar
                                                                            )
                                                                          ) +
                                                                          "\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("h4", [
                                            _vm._v("Section 1 Status: "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.s1StatusClasses,
                                                  "fontMatchParent"
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[
                                                      this.traffickingScreening
                                                        .section_1_status
                                                    ]
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title: "Section 2: Perpetrator Actions",
                                        disabled:
                                          this.isSection1Checked === false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "screening__header screening__header--italic"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        Has someone facilitated, enticed, or benefitted from the sexual activity of the child/youth?\n                                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c("i", [
                                          _vm._v(
                                            "This may be a parent, family member, friend, employer, or romantic partner. Select all that apply."
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "screening__form" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.isTraffickingScreeningCreated ||
                                                  _vm.s2Disabled,
                                                "label-size": "lg",
                                                "label-class": "bold",
                                                label: "Exploitation Indicators"
                                              }
                                            },
                                            [
                                              _c("p", [_vm._v("Someone has:")]),
                                              _vm._v(" "),
                                              _vm._l(
                                                Object.entries(
                                                  _vm.section2Fields[
                                                    "Exploitation"
                                                  ]
                                                ),
                                                function(ref) {
                                                  var key = ref[0]
                                                  var value = ref[1]
                                                  return _c(
                                                    "b-form-checkbox",
                                                    {
                                                      key: key,
                                                      class: {
                                                        bold: value.boldDesc
                                                      },
                                                      attrs: { size: "lg" },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .traffickingScreening[
                                                            key
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.traffickingScreening,
                                                            key,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "traffickingScreening[key]"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(value.desc) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.isTraffickingScreeningCreated,
                                                "label-size": "lg",
                                                "label-class": "bold",
                                                label:
                                                  "Vulnerability Indicators"
                                              }
                                            },
                                            [
                                              _c("p", [_vm._v("Someone is:")]),
                                              _vm._v(" "),
                                              _vm._l(
                                                Object.entries(
                                                  _vm.section2Fields[
                                                    "Vulnerability"
                                                  ]
                                                ),
                                                function(ref) {
                                                  var key = ref[0]
                                                  var value = ref[1]
                                                  return _c(
                                                    "div",
                                                    { key: key },
                                                    [
                                                      !value.type
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  class: {
                                                                    bold:
                                                                      value.boldDesc,
                                                                    marginTop32: key.includes(
                                                                      "no_circumstances"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    disabled:
                                                                      !key.includes(
                                                                        "no_circumstances"
                                                                      ) &&
                                                                      _vm.s2Disabled,
                                                                    size: "lg"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .traffickingScreening[
                                                                        key
                                                                      ],
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.traffickingScreening,
                                                                        key,
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "traffickingScreening[key]"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        value.desc
                                                                      ) +
                                                                      "\n                                                "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      value.type === "other"
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.s2Disabled,
                                                                    size: "lg"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .traffickingScreening[
                                                                        key
                                                                      ],
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.traffickingScreening,
                                                                        key,
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "traffickingScreening[key]"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        value.desc
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm
                                                                    .traffickingScreening[
                                                                    key
                                                                  ]
                                                                    ? _c(
                                                                        "b-form-textarea",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                "required",
                                                                              expression:
                                                                                "'required'"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "screening__form-input",
                                                                          attrs: {
                                                                            "data-vv-name":
                                                                              value.textVar,
                                                                            "data-vv-as":
                                                                              "Other",
                                                                            id:
                                                                              value.textVar,
                                                                            name:
                                                                              value.textVar,
                                                                            maxlength: 255
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .traffickingScreening[
                                                                                value
                                                                                  .textVar
                                                                              ],
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.traffickingScreening,
                                                                                value.textVar,
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "traffickingScreening[value.textVar]"
                                                                          }
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm.inputValidationErrors.has(
                                                                              value.textVar
                                                                            ) &&
                                                                            _vm
                                                                              .traffickingScreening[
                                                                              key
                                                                            ],
                                                                          expression:
                                                                            "inputValidationErrors.has(value.textVar) && traffickingScreening[key]"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "text-info"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            _vm.inputValidationErrors.first(
                                                                              value.textVar
                                                                            )
                                                                          ) +
                                                                          "\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "fontSize22" },
                                            [
                                              _c("b", [
                                                _vm._v("Section 2 Status: ")
                                              ]),
                                              _c(
                                                "span",
                                                { class: _vm.s2StatusClasses },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[
                                                        this
                                                          .traffickingScreening
                                                          .section_2_status
                                                      ]
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title: "Section 3: Current Abuse",
                                        disabled:
                                          this.isSection1Checked === false ||
                                          this.isSection2Checked === false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "screening__header screening__header--italic"
                                        },
                                        [
                                          _vm._v(
                                            "Is the child/youth currently experiencing abuse, neglect, or other forms of harm?"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c("i", [
                                          _vm._v(
                                            "Please select which types of abuse, neglect, or other forms of harm (from the last 90 days) you have knowledge of or concerns about for this child/youth. Select all that apply"
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "screening__form" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.isTraffickingScreeningCreated,
                                                "label-size": "lg",
                                                "label-class": "bold",
                                                label:
                                                  "Vulnerability Indicators"
                                              }
                                            },
                                            _vm._l(
                                              Object.entries(
                                                _vm.section3Fields
                                              ),
                                              function(ref) {
                                                var key = ref[0]
                                                var value = ref[1]
                                                return _c("div", { key: key }, [
                                                  !value.type
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "b-form-checkbox",
                                                            {
                                                              class: {
                                                                bold:
                                                                  value.boldDesc,
                                                                marginTop32: key.includes(
                                                                  "no_circumstances"
                                                                )
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  !key.includes(
                                                                    "no_circumstances"
                                                                  ) &&
                                                                  _vm.s3Disabled,
                                                                size: "lg"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .traffickingScreening[
                                                                    key
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.traffickingScreening,
                                                                    key,
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "traffickingScreening[key]"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    value.desc
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  value.type === "other"
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "b-form-checkbox",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.s3Disabled,
                                                                size: "lg"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .traffickingScreening[
                                                                    key
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.traffickingScreening,
                                                                    key,
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "traffickingScreening[key]"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    value.desc
                                                                  ) +
                                                                  "\n                                                    "
                                                              ),
                                                              _vm._v(" "),
                                                              _vm
                                                                .traffickingScreening[
                                                                key
                                                              ]
                                                                ? _c(
                                                                    "b-form-textarea",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "validate",
                                                                          rawName:
                                                                            "v-validate",
                                                                          value:
                                                                            "required",
                                                                          expression:
                                                                            "'required'"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "screening__form-input",
                                                                      attrs: {
                                                                        "data-vv-name":
                                                                          value.textVar,
                                                                        "data-vv-as":
                                                                          "Other",
                                                                        id:
                                                                          value.textVar,
                                                                        name:
                                                                          value.textVar,
                                                                        maxlength: 255
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .traffickingScreening[
                                                                            value
                                                                              .textVar
                                                                          ],
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.traffickingScreening,
                                                                            value.textVar,
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "traffickingScreening[value.textVar]"
                                                                      }
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        _vm.inputValidationErrors.has(
                                                                          value.textVar
                                                                        ) &&
                                                                        _vm
                                                                          .traffickingScreening[
                                                                          key
                                                                        ],
                                                                      expression:
                                                                        "inputValidationErrors.has(value.textVar) && traffickingScreening[key]"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "text-info"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.inputValidationErrors.first(
                                                                          value.textVar
                                                                        )
                                                                      ) +
                                                                      "\n                                                    "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ])
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "fontSize22" },
                                            [
                                              _c("b", [
                                                _vm._v("Section 3 Status: ")
                                              ]),
                                              _c(
                                                "span",
                                                { class: _vm.s3StatusClasses },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[
                                                        this
                                                          .traffickingScreening
                                                          .section_3_status
                                                      ]
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title: "Location",
                                        disabled:
                                          this.isSection1Checked === false ||
                                          this.isSection2Checked === false ||
                                          this.isSection3Checked === false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "screening__header" },
                                        [
                                          _vm._v(
                                            "\n                                        Select Your Sex Trafficking Screening Location and Program:\n                                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "screening__description"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        Select the location and program where this Sex Trafficking Screening occurred. If location and program are not selected, it will default to the primary location and program of the organization.\n                                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            "label-size": "lg",
                                            label: "Location",
                                            "label-for": "location",
                                            horizontal: false
                                          }
                                        },
                                        [
                                          !_vm.isTraffickingScreeningCreated
                                            ? _c(
                                                "b-form-select",
                                                {
                                                  attrs: {
                                                    id: "location",
                                                    options:
                                                      _vm.locationOptions,
                                                    placeholder:
                                                      "Select a Location"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.traffickingScreening
                                                        .location,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.traffickingScreening,
                                                        "location",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "traffickingScreening.location"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.traffickingScreening
                                                          .location
                                                      ) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "screening__description"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(_vm.locationName) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            "label-size": "lg",
                                            label: "Program",
                                            "label-for": "program",
                                            horizontal: false
                                          }
                                        },
                                        [
                                          !_vm.isTraffickingScreeningCreated
                                            ? _c(
                                                "b-form-select",
                                                {
                                                  attrs: {
                                                    id: "program",
                                                    options: _vm.programOptions,
                                                    placeholder:
                                                      "Select a Program"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.traffickingScreening
                                                        .program,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.traffickingScreening,
                                                        "program",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "traffickingScreening.program"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.traffickingScreening
                                                          .program
                                                      ) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "screening__description"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(_vm.programName) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.isExisting
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "screening__button-wrapper button-container"
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "secondary" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.cancelModal.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _vm._v(" "),
                                          _vm.showPreviousBtn
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "outline-primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.prevScreeningTab.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Previous")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showNextBtn
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.nextScreeningTab.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Next")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showSubmitBtn
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.submit.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Submit")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Conclusion",
                        disabled: _vm.disabledConclusionTab
                      }
                    },
                    [
                      _c("b-card", [
                        _c("p", { staticClass: "screening__description" }, [
                          _c("b", [
                            _c("i", [
                              _vm._v(
                                "If the child/youth is in immediate danger or if there is an active safety concern, immediately call 911 and report to law enforcement. Review the User Guide for additional actions and guidance."
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("h5", { staticClass: "screening__header" }, [
                          _vm._v("Summary:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "screening__table" },
                          [
                            _c(
                              "b-row",
                              { staticClass: "screening__row" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "screening__col",
                                    attrs: { cols: "10" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                                        Section 1: Commercial Sexual Activity\n                                    "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "screening__col",
                                    attrs: { cols: "2" }
                                  },
                                  [
                                    _c("b-checkbox", {
                                      attrs: {
                                        checked: _vm.isSection1Checked,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "screening__row" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "screening__col",
                                    attrs: { cols: "10" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                                        Section 2: Perpetrator Actions\n                                    "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "screening__col",
                                    attrs: { cols: "2" }
                                  },
                                  [
                                    _c("b-checkbox", {
                                      attrs: {
                                        checked: _vm.isSection2Checked,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "screening__row" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "screening__col",
                                    attrs: { cols: "10" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                                    Section 3: Current Abuse\n                                    "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "screening__col",
                                    attrs: { cols: "2" }
                                  },
                                  [
                                    _c("b-checkbox", {
                                      attrs: {
                                        checked: _vm.isSection3Checked,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "screening__conclusion screening__description"
                          },
                          [
                            _c("h5", { staticClass: "screening__header" }, [
                              _vm._v("Final Screening Results and Actions:")
                            ]),
                            _vm._v(" "),
                            _vm.traffickingScreening.conclusion ===
                            _vm.TRAFFICKING_SCREENING_CONCLUSION_ENUM
                              .NOT_ENOUGH_INFO
                              ? _c("div", [
                                  _c("h5", { class: _vm.conclusionClasses }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[
                                          this.traffickingScreening.conclusion
                                        ]
                                      ) + " [Monitor]"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "There is not enough information to determine whether the child/youth is experiencing sex trafficking. "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        "Continue to monitor the child/youth"
                                      )
                                    ]),
                                    _vm._v(
                                      "; upon learning more information, re-screen the child/youth."
                                    )
                                  ])
                                ])
                              : _vm.traffickingScreening.conclusion ===
                                _vm.TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL1
                              ? _c("div", [
                                  _c("h5", { class: _vm.conclusionClasses }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[
                                          this.traffickingScreening.conclusion
                                        ]
                                      ) + " [Re-Screen]"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "There is concern for possible sex trafficking. If you are a mandatory reporter and have suspicion or knowledge of child abuse (ex: physical or sexual abuse) or neglect (ex: malnourishment), you are required by law to make a mandatory report to DCFS or law enforcement. "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        "Screen again in 90 days or upon learning new information"
                                      )
                                    ]),
                                    _vm._v(
                                      ". Consider referring the child/youth to additional services as needed and appropriate. Consider utilizing the group sharing feature on the top right hand corner of this page to share this record with your region's care coordination team."
                                    )
                                  ])
                                ])
                              : _vm.traffickingScreening.conclusion ===
                                _vm.TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL2
                              ? _c("div", [
                                  _c("h5", { class: _vm.conclusionClasses }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[
                                          this.traffickingScreening.conclusion
                                        ]
                                      ) + " [Report]"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "The child/youth is considered “indicated” for sex trafficking. As a result, this case warrants review by a Louisiana Human Trafficking Regional Care Coordination Team. "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        "Immediately call the DCFS Child Abuse/Neglect Hotline at 855-452-5437 (option 4) to report human trafficking involving a child under the age of 18 years old"
                                      )
                                    ]),
                                    _vm._v(
                                      ". If the youth is aged 18 years or older, provide them with the National Human Trafficking Hotline at 888-373-7888 and offer to make a referral to a local service provider with expertise in human trafficking. If the suspected victim is an adult with a disability, report also to Adult Protective Services at 800-898-4910. "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        "Utilize the group sharing feature on the top right hand corner of this page to share this record with your region's care coordination team"
                                      )
                                    ]),
                                    _vm._v(".")
                                  ])
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "screening__description" }, [
                          _c("b", [
                            _vm._v(
                              "\n                                Location:\n                            "
                            )
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.locationName) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "screening__description" }, [
                          _c("b", [
                            _vm._v(
                              "\n                                Program:\n                            "
                            )
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.programName) +
                              "\n                        "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isTraffickingScreeningCreated
            ? _c(
                "b-col",
                { attrs: { sm: "3" } },
                [
                  _c("SharePersonList", {
                    attrs: {
                      personId: _vm.traffickingScreening.person._id,
                      personOrganizationOwner:
                        _vm.traffickingScreening.person.organizationOwner
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      attrs: {
                        "no-body": "",
                        title: _vm.traffickingScreening.id
                      }
                    },
                    [
                      _c("b-card-header", [_c("b", [_vm._v("Meta")])]),
                      _vm._v(" "),
                      _c("b-card-body", [
                        _c("p", { staticClass: "card-text" }, [
                          _c(
                            "small",
                            { staticClass: "text-muted text-uppercase bold" },
                            [_vm._v("LA Sex Trafficking Screening ID: ")]
                          ),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v(
                              " " + _vm._s(_vm.traffickingScreening.id) + " "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-text" }, [
                          _c(
                            "small",
                            { staticClass: "text-muted text-uppercase bold" },
                            [_vm._v("Person ID")]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "small",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to:
                                      "/person/" +
                                      _vm.traffickingScreening.person.id
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.traffickingScreening.person.id
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-list-group",
                        { attrs: { flush: "" } },
                        [
                          _c(
                            "b-list-group-item",
                            { staticClass: "small text-muted" },
                            [
                              _c("b", [_vm._v("Created At: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getCreatedAt()) +
                                  "\n                        "
                              ),
                              _vm._.isObject(_vm.traffickingScreening.createdBy)
                                ? _c("div", [
                                    _c("b", [_vm._v(" by: ")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._.get(
                                            _vm.traffickingScreening,
                                            "createdBy.emailAddress",
                                            ""
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("b", [_vm._v("Last Updated: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getLastUpdateDate()) +
                                  "\n                        "
                              ),
                              _vm._.isObject(_vm.traffickingScreening.updatedBy)
                                ? _c("div", [
                                    _c("b", [_vm._v(" by: ")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._.get(
                                            _vm.traffickingScreening,
                                            "updatedBy.emailAddress",
                                            ""
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            { staticClass: "small text-muted" },
                            [
                              _c("p", { staticClass: "card-text" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "text-muted text-uppercase bold"
                                  },
                                  [_vm._v("Current Record Owner")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _c("b", [_vm._v(" by: ")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.traffickingScreening,
                                          "organizationOwner.title"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "screening__wrapper" },
        [
          _vm.isTraffickingScreeningCreated
            ? _c(
                "b-button",
                {
                  staticClass: "mb-2 mt-2",
                  attrs: { type: "button", variant: "primary", size: "md" },
                  on: { click: _vm.print }
                },
                [
                  _c("span", { staticClass: "button-text" }, [
                    _vm._v("\n                Print\n            ")
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        _vm._b(
          {
            ref: "noSelectionModal",
            attrs: { "ok-only": "" },
            scopedSlots: _vm._u([
              {
                key: "modal-header-close",
                fn: function() {
                  return [_c("h4", [_vm._v("X")])]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.showNoSelectionModal,
              callback: function($$v) {
                _vm.showNoSelectionModal = $$v
              },
              expression: "showNoSelectionModal"
            }
          },
          "b-modal",
          {
            centered: true,
            title: "Sex Trafficking Screening - " + this.noSelectionSection,
            size: "lg",
            "ok-title": "Okay",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            class: "tos-modal",
            "hide-header-close": true,
            "no-close-on-backdrop": true
          },
          false
        ),
        [
          _vm._v(" "),
          this.noSelectionSection === "Introduction"
            ? _c("p", [
                _vm._v(
                  "Please select the pre-screening criteria that applies to the child/youth prior to continuing with the screening."
                )
              ])
            : _c("p", [
                _vm._v(
                  "If none of these circumstances apply for the youth, please go back and select the I am not aware of these circumstances applying to the youth/child option."
                )
              ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        _vm._b(
          {
            ref: "cancelModal",
            on: { cancel: _vm.goBackToPersonRecord },
            scopedSlots: _vm._u([
              {
                key: "modal-header-close",
                fn: function() {
                  return [_c("h4", [_vm._v("X")])]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.showCancelModal,
              callback: function($$v) {
                _vm.showCancelModal = $$v
              },
              expression: "showCancelModal"
            }
          },
          "b-modal",
          _vm.cancelModalProps,
          false
        ),
        [
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.cancelModalDescription) +
                "\n        "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b6fe0ac", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b6fe0ac","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/TraffickingScreening.vue
// module id = 1772
// module chunks = 0